// extracted by mini-css-extract-plugin
export default {"root":"Stub__root--2sDkM","regular":"Stub__regular--3TKeZ","button":"Stub__button---cr5Y"};